module.exports = __webpack_public_path__ + "img/9791189015541.1488b09c.jpg";